module.exports = __webpack_public_path__ + "img/retailer-apple.6c6258f7.svg";